import Phaser from 'phaser'
import { GameData } from '../core/GameData'
import { InputManager } from '../core/InputManager'
import { SettingsManager } from '../core/SettingsManager'
import { queueImageAsset } from '../core/AssetLoader'
import { AudioManager } from '../core/AudioManager'
import { LOADING_SCREEN, TITLE_BACKGROUND } from '../utils/constants'
import { showLoadingScreen } from '../utils/loadingScreen'
import { markStartupReady } from '../utils/startup'
import { getRequestedBattleVisualQaConfig, isMainlineQaRequested, prepareBattleVisualQa, runMainlineQa } from '../qa/MainlineQaRunner'

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' })
  }

  preload(): void {
    showLoadingScreen(this, LOADING_SCREEN.STARTUP_LABEL)
    queueImageAsset(this, LOADING_SCREEN.BACKGROUND_KEY)
    queueImageAsset(this, TITLE_BACKGROUND.IMAGE_KEY)
    this.load.video(TITLE_BACKGROUND.VIDEO_KEY, TITLE_BACKGROUND.VIDEO_PATH, TITLE_BACKGROUND.VIDEO_NO_AUDIO)
    AudioManager.getInstance().preload(this.load)
  }

  create(): void {
    const gd = GameData.getInstance()
    if (gd.characters.size === 0) {
      gd.reset()
    }
    SettingsManager.getInstance().load()
    InputManager.getInstance().syncFromGameData()

    if (isMainlineQaRequested()) {
      runMainlineQa()
      markStartupReady()
      this.scene.start('MapScene', { mapId: gd.currentMap })
      return
    }

    const battleVisualQaConfig = getRequestedBattleVisualQaConfig()
    if (battleVisualQaConfig) {
      prepareBattleVisualQa(battleVisualQaConfig)
      markStartupReady()
      this.scene.start('BattleScene', { encounterId: battleVisualQaConfig.encounterId, mapId: battleVisualQaConfig.mapId })
      return
    }

    markStartupReady()
    this.scene.start('TitleScene')
  }
}
